import { FilterOption } from './FilterTypes';

export const audioContentTypes: FilterOption[] = [
    {
        label: 'All',
        value: '',
        urlId: '',
    },
    {
        label: 'Music',
        value: 'music',
        urlId: 'music',
    },
    {
        label: 'Sound Effects',
        value: 'sound-effects',
        urlId: 'sound-effects',
    },
];

export const musicInstruments: FilterOption[] = [
    {
        label: 'Brass',
        value: '41',
        urlId: 'brass',
        apiKey: 'instruments',
    },
    {
        label: 'Guitar',
        value: '40',
        urlId: 'guitar-instrument',
        apiKey: 'instruments',
    },
    {
        label: 'Orchestra',
        value: '39',
        urlId: 'orchestra',
        apiKey: 'instruments',
    },
    {
        label: 'Percussion',
        value: '42',
        urlId: 'percussion-instrument',
        apiKey: 'instruments',
    },
    {
        label: 'Piano',
        value: '45',
        urlId: 'piano',
        apiKey: 'instruments',
    },
    {
        label: 'Synth',
        value: '119',
        urlId: 'synth',
        apiKey: 'instruments',
    },
    {
        label: 'Woodwind',
        value: '44',
        urlId: 'woodwind',
        apiKey: 'instruments',
    },
];

export const moods: FilterOption[] = [
    {
        label: 'Angry',
        value: '1',
        urlId: 'angry',
        apiKey: 'mood',
    },
    {
        label: 'Dark',
        value: '125',
        urlId: 'dark',
        apiKey: 'mood',
    },
    {
        label: 'Epic',
        value: '124',
        urlId: 'epic',
        apiKey: 'mood',
    },
    {
        label: 'Happy',
        value: '7',
        urlId: 'happy',
        apiKey: 'mood',
    },
    {
        label: 'Inspiring',
        value: '4',
        urlId: 'inspiring',
        apiKey: 'mood',
    },
    {
        label: 'Love',
        value: '8',
        urlId: 'love',
        apiKey: 'mood',
    },
    {
        label: 'Playful',
        value: '3',
        urlId: 'playful',
        apiKey: 'mood',
    },
    {
        label: 'Relaxing',
        value: '6',
        urlId: 'relaxing',
        apiKey: 'mood',
    },
    {
        label: 'Sad',
        value: '5',
        urlId: 'sad',
        apiKey: 'mood',
    },
    {
        label: 'Serious',
        value: '2',
        urlId: 'serious',
        apiKey: 'mood',
    },
];

export const genres: FilterOption[] = [
    {
        label: 'Ambient',
        value: '33',
        urlId: 'ambient',
        apiKey: 'genres',
    },
    {
        label: 'Blues',
        value: '36',
        urlId: 'blues',
        apiKey: 'genres',
    },
    {
        label: 'Bumpers & Stingers',
        value: '38',
        urlId: 'bumpers-and-stingers',
        apiKey: 'genres',
    },
    {
        label: 'Chill Out',
        value: '10',
        urlId: 'chill-out',
        apiKey: 'genres',
    },
    {
        label: 'Cinematic',
        value: '11',
        urlId: 'cinematic',
        apiKey: 'genres',
    },
    {
        label: 'Classical',
        value: '32',
        urlId: 'classical',
        apiKey: 'genres',
    },
    {
        label: 'Corporate',
        value: '22',
        urlId: 'corporate',
        apiKey: 'genres',
    },
    {
        label: 'Country',
        value: '13',
        urlId: 'country',
        apiKey: 'genres',
    },
    {
        label: 'Electronic',
        value: '37',
        urlId: 'electronic',
        apiKey: 'genres',
    },
    {
        label: 'Folk',
        value: '118',
        urlId: 'folk',
        apiKey: 'genres',
    },
    {
        label: 'Hip Hop',
        value: '20',
        urlId: 'hip-hop',
        apiKey: 'genres',
    },
    {
        label: 'Holidays & Special Events',
        value: '25',
        urlId: 'holidays-and-special-events',
        apiKey: 'genres',
    },
    {
        label: 'Horror',
        value: '26',
        urlId: 'horror',
        apiKey: 'genres',
    },
    {
        label: 'Jazz',
        value: '29',
        urlId: 'jazz',
        apiKey: 'genres',
    },
    {
        label: 'Kids & Family',
        value: '31',
        urlId: 'kids-and-family',
        apiKey: 'genres',
    },
    {
        label: 'Pop',
        value: '15',
        urlId: 'pop',
        apiKey: 'genres',
    },
    {
        label: 'R&B',
        value: '116',
        urlId: 'rhythm-and-blues',
        apiKey: 'genres',
    },
    {
        label: 'Religious',
        value: '34',
        urlId: 'religious',
        apiKey: 'genres',
    },
    {
        label: 'Rock',
        value: '9',
        urlId: 'rock',
        apiKey: 'genres',
    },
    {
        label: 'World',
        value: '21',
        urlId: 'world',
        apiKey: 'genres',
    },
];

export const vocalType: FilterOption[] = [
    {
        label: 'All',
        value: '',
        urlId: '',
    },
    {
        label: 'Vocals/Lyrical',
        value: 'true',
        urlId: 'true',
    },
    {
        label: 'No Vocals/Instrumental',
        value: 'false',
        urlId: 'false',
    },
];

export const sfxCategories: FilterOption[] = [
    {
        label: 'Alarms',
        value: '46',
        urlId: 'alarms',
        apiKey: 'categories',
    },
    {
        label: 'Ambience',
        value: '47',
        urlId: 'ambient',
        apiKey: 'categories',
    },
    {
        label: 'Animals',
        value: '48',
        urlId: 'animals',
        apiKey: 'categories',
    },
    {
        label: 'Applause',
        value: '92',
        urlId: 'applause',
        apiKey: 'categories',
    },
    {
        label: 'Balloon',
        value: '105',
        urlId: 'balloon',
        apiKey: 'categories',
    },
    {
        label: 'Bangs',
        value: '49',
        urlId: 'bangs',
        apiKey: 'categories',
    },
    {
        label: 'Bathroom',
        value: '50',
        urlId: 'bathroom',
        apiKey: 'categories',
    },
    {
        label: 'Bells',
        value: '51',
        urlId: 'bells',
        apiKey: 'categories',
    },
    {
        label: 'Birds',
        value: '52',
        urlId: 'birds',
        apiKey: 'categories',
    },
    {
        label: 'Boats',
        value: '53',
        urlId: 'boats',
        apiKey: 'categories',
    },
    {
        label: 'Breaking',
        value: '54',
        urlId: 'breaking',
        apiKey: 'categories',
    },
    {
        label: 'Buzzers',
        value: '55',
        urlId: 'buzzers',
        apiKey: 'categories',
    },
    {
        label: 'Cartoon',
        value: '57',
        urlId: 'cartoon',
        apiKey: 'categories',
    },
    {
        label: 'Casino',
        value: '58',
        urlId: 'casino',
        apiKey: 'categories',
    },
    {
        label: 'City',
        value: '91',
        urlId: 'city',
        apiKey: 'categories',
    },
    {
        label: 'Clicks',
        value: '59',
        urlId: 'clicks',
        apiKey: 'categories',
    },
    {
        label: 'Clocks',
        value: '89',
        urlId: 'clocks',
        apiKey: 'categories',
    },
    {
        label: 'Computer',
        value: '96',
        urlId: 'computer',
        apiKey: 'categories',
    },
    {
        label: 'Crowds',
        value: '60',
        urlId: 'crowds',
        apiKey: 'categories',
    },
    {
        label: 'Dogs',
        value: '61',
        urlId: 'dogs',
        apiKey: 'categories',
    },
    {
        label: 'Doors',
        value: '62',
        urlId: 'doors',
        apiKey: 'categories',
    },
    {
        label: 'Effects',
        value: '63',
        urlId: 'effects',
        apiKey: 'categories',
    },
    {
        label: 'Electronics',
        value: '106',
        urlId: 'electronics',
        apiKey: 'categories',
    },
    {
        label: 'Emergency',
        value: '102',
        urlId: 'emergency',
        apiKey: 'categories',
    },
    {
        label: 'Explosion',
        value: '98',
        urlId: 'explosion',
        apiKey: 'categories',
    },
    {
        label: 'Falling',
        value: '64',
        urlId: 'falling',
        apiKey: 'categories',
    },
    {
        label: 'Festive',
        value: '65',
        urlId: 'festive',
        apiKey: 'categories',
    },
    {
        label: 'Fight',
        value: '100',
        urlId: 'fight',
        apiKey: 'categories',
    },
    {
        label: 'Fire',
        value: '66',
        urlId: 'fire',
        apiKey: 'categories',
    },
    {
        label: 'Flight',
        value: '67',
        urlId: 'flight',
        apiKey: 'categories',
    },
    {
        label: 'Foley',
        value: '107',
        urlId: 'foley',
        apiKey: 'categories',
    },
    {
        label: 'Footsteps',
        value: '68',
        urlId: 'footsteps',
        apiKey: 'categories',
    },
    {
        label: 'Friction',
        value: '69',
        urlId: 'friction',
        apiKey: 'categories',
    },
    {
        label: 'Furniture',
        value: '95',
        urlId: 'furniture',
        apiKey: 'categories',
    },
    {
        label: 'Glass',
        value: '108',
        urlId: 'glass',
        apiKey: 'categories',
    },
    {
        label: 'Horror',
        value: '94',
        urlId: 'horror',
        apiKey: 'categories',
    },
    {
        label: 'House',
        value: '71',
        urlId: 'house',
        apiKey: 'categories',
    },
    {
        label: 'Impact',
        value: '103',
        urlId: 'impact',
        apiKey: 'categories',
    },
    {
        label: 'Industrial',
        value: '72',
        urlId: 'industrial',
        apiKey: 'categories',
    },
    {
        label: 'Insects',
        value: '90',
        urlId: 'insects',
        apiKey: 'categories',
    },
    {
        label: 'Kitchen',
        value: '73',
        urlId: 'kitchen',
        apiKey: 'categories',
    },
    {
        label: 'Magic',
        value: '99',
        urlId: 'magic',
        apiKey: 'categories',
    },
    {
        label: 'Misc',
        value: '74',
        urlId: 'misc',
        apiKey: 'categories',
    },
    {
        label: 'Money',
        value: '75',
        urlId: 'money',
        apiKey: 'categories',
    },
    {
        label: 'Nature',
        value: '93',
        urlId: 'nature',
        apiKey: 'categories',
    },
    {
        label: 'Office',
        value: '76',
        urlId: 'office',
        apiKey: 'categories',
    },
    {
        label: 'Paper',
        value: '77',
        urlId: 'paper',
        apiKey: 'categories',
    },
    {
        label: 'People',
        value: '78',
        urlId: 'people',
        apiKey: 'categories',
    },
    {
        label: 'Phones',
        value: '79',
        urlId: 'phones',
        apiKey: 'categories',
    },
    {
        label: 'Ripping',
        value: '80',
        urlId: 'ripping',
        apiKey: 'categories',
    },
    {
        label: 'Scifi',
        value: '81',
        urlId: 'scifi',
        apiKey: 'categories',
    },
    {
        label: 'Sports',
        value: '104',
        urlId: 'sports',
        apiKey: 'categories',
    },
    {
        label: 'Squeaks',
        value: '82',
        urlId: 'squeaks',
        apiKey: 'categories',
    },
    {
        label: 'Tools and Machines',
        value: '83',
        urlId: 'tools-and-machines',
        apiKey: 'categories',
    },
    {
        label: 'Toys and Games',
        value: '70',
        urlId: 'toys-and-games',
        apiKey: 'categories',
    },
    {
        label: 'Trains',
        value: '84',
        urlId: 'trains',
        apiKey: 'categories',
    },
    {
        label: 'Vehicle and Traffic',
        value: '56',
        urlId: 'vehicle-and-traffic',
        apiKey: 'categories',
    },
    {
        label: 'Water',
        value: '85',
        urlId: 'water',
        apiKey: 'categories',
    },
    {
        label: 'Weapons',
        value: '86',
        urlId: 'weapons',
        apiKey: 'categories',
    },
    {
        label: 'Weather',
        value: '88',
        urlId: 'weather',
        apiKey: 'categories',
    },
    {
        label: 'Whistles',
        value: '87',
        urlId: 'whistles',
        apiKey: 'categories',
    },
    {
        label: 'Whoosh',
        value: '97',
        urlId: 'whoosh',
        apiKey: 'categories',
    },
    {
        label: 'Wood',
        value: '101',
        urlId: 'wood',
        apiKey: 'categories',
    },
];

export const allMusicCategories: FilterOption[] = [...moods, ...genres, ...musicInstruments];
